@if(isOpen){
<div class="overlay">
    &nbsp;
</div>
<div class="message-box-wrapper center-full">
    <div class="row">
        <div class="col-10">
            <ngx-select [disabled]="optionsTemp.length == 1" *ngIf="optionsTemp.length > 0"
                [(ngModel)]="selecetdOptionKey" [noAutoComplete]="true" [items]="optionsTemp" [optionValueField]="'key'"
                [optionTextField]="'value'" (select)="onAction(2)">
            </ngx-select>
        </div>
        <div class="col-2" style="text-align: right;">
            <button class="button_icon button_icon_color"
                style="transform: rotate(45deg);font-size: 25px !important; color: red !important;"
                title="{{localService.languageContent.common.close}}" (click)="onAction(1)">add_circle_outline</button>
        </div>
    </div>
    <div style="text-align: center;" class="row">
        <div class="col-12">
            <div style="height: 400px;width: 400px;">
                <qrcode *ngIf="!isLoading && barcodeValue && barcodeValue.length > 0" [qrdata]="barcodeValue"
                    [width]="400" [errorCorrectionLevel]="'H'">
                </qrcode>
            </div>
        </div>
    </div>
    <div class="row" *ngFor="let item of texts">
        <div class="col-6" style="text-align:right;">
            <label>{{item.key}}</label>
        </div>
        <div class="col-6">
            {{item.value}}
        </div>
    </div>
</div>
}